class MegaMenuNavigation extends HTMLElement {
  constructor() {
    super();
    this.finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
    this.handleDocumentPointerDown = this.handleDocumentPointerDown.bind(this);
    this.handleBlockSelect = this.handleBlockSelect.bind(this);
  }

  connectedCallback() {
    if (this.dataset.initialized === 'true') return;

    this.dataset.initialized = 'true';
    this.items = Array.from(this.querySelectorAll('[data-mega-menu-item]'));
    this.closeTimers = new WeakMap();

    this.items.forEach((item) => {
      const trigger = item.querySelector('[data-mega-menu-trigger]');
      if (!trigger) return;

      item.addEventListener('pointerenter', () => {
        if (!this.finePointer.matches) return;

        this.cancelClose(item);
        this.openItem(item);
      });

      item.addEventListener('pointerleave', () => {
        if (this.finePointer.matches && !item.contains(document.activeElement)) this.scheduleClose(item);
      });

      item.addEventListener('focusin', () => {
        this.cancelClose(item);
        this.openItem(item);
      });
      item.addEventListener('focusout', () => {
        window.setTimeout(() => {
          if (!item.contains(document.activeElement)) this.closeItem(item);
        });
      });

      trigger.addEventListener('click', (event) => {
        if (this.finePointer.matches || item.classList.contains('is-open')) return;

        event.preventDefault();
        this.openItem(item);
      });

      item.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;

        this.closeItem(item);
        trigger.focus();
      });
    });

    document.addEventListener('pointerdown', this.handleDocumentPointerDown);
    document.addEventListener('shopify:block:select', this.handleBlockSelect);
  }

  disconnectedCallback() {
    document.removeEventListener('pointerdown', this.handleDocumentPointerDown);
    document.removeEventListener('shopify:block:select', this.handleBlockSelect);
    this.items?.forEach((item) => this.cancelClose(item));
    delete this.dataset.initialized;
  }

  openItem(item) {
    this.cancelClose(item);

    this.items.forEach((candidate) => {
      if (candidate !== item) this.closeItem(candidate);
    });

    item.classList.add('is-open');
    item.querySelector('[data-mega-menu-trigger]')?.setAttribute('aria-expanded', 'true');
  }

  closeItem(item) {
    this.cancelClose(item);
    item.classList.remove('is-open');
    item.querySelector('[data-mega-menu-trigger]')?.setAttribute('aria-expanded', 'false');
  }

  scheduleClose(item) {
    this.cancelClose(item);

    const timer = window.setTimeout(() => {
      item.classList.remove('is-open');
      item.querySelector('[data-mega-menu-trigger]')?.setAttribute('aria-expanded', 'false');
      this.closeTimers.delete(item);
    }, 180);

    this.closeTimers.set(item, timer);
  }

  cancelClose(item) {
    const timer = this.closeTimers?.get(item);
    if (!timer) return;

    window.clearTimeout(timer);
    this.closeTimers.delete(item);
  }

  handleDocumentPointerDown(event) {
    if (this.contains(event.target)) return;
    this.items.forEach((item) => this.closeItem(item));
  }

  handleBlockSelect(event) {
    if (!this.contains(event.target)) return;

    const item = event.target.closest('[data-mega-menu-item]');
    if (item) this.openItem(item);
  }
}

if (!customElements.get('mega-menu-navigation')) {
  customElements.define('mega-menu-navigation', MegaMenuNavigation);
}
